import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

export default function MemberDashboard() {
  const { user } = useAuth();
  const profile = user?.profile;
  const [payments, setPayments] = useState([]);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    api.get('/payments/my/').then(res => setPayments(res.data.results || res.data)).catch(() => {});
    api.get('/announcements/member/').then(res => setAnnouncements(res.data.results || res.data)).catch(() => {});
  }, []);

  const stats = [
    { label: 'Membership Status', value: profile?.membership_status || 'N/A', color: profile?.membership_status === 'active' ? 'text-green-600' : 'text-yellow-600' },
    { label: 'CPD Points', value: profile?.total_cpd_points || 0, color: 'text-blue-600' },
    { label: 'Dues Status', value: profile?.dues_status || 'N/A', color: profile?.dues_status === 'paid' ? 'text-green-600' : 'text-red-600' },
    { label: 'Category', value: profile?.membership_category || 'N/A', color: 'text-gray-700' },
  ];

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">
          Welcome, {user?.first_name} {user?.last_name}
        </h1>
        <p className="text-gray-500">Membership No: {profile?.membership_number || 'Pending'}</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((s, i) => (
          <div key={i} className="bg-white rounded-xl shadow-sm border p-6">
            <p className="text-sm text-gray-500 mb-1">{s.label}</p>
            <p className={`text-xl font-bold capitalize ${s.color}`}>{s.value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Recent Payments */}
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Recent Payments</h2>
          {payments.length === 0 ? (
            <p className="text-gray-500 text-sm">No payment records yet.</p>
          ) : (
            <div className="space-y-3">
              {payments.slice(0, 5).map((p) => (
                <div key={p.id} className="flex justify-between items-center py-2 border-b last:border-0">
                  <div>
                    <p className="font-medium text-sm">{p.payment_type}</p>
                    <p className="text-xs text-gray-500">{p.reference}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold text-sm">₦{Number(p.amount).toLocaleString()}</p>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${
                      p.status === 'completed' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {p.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Announcements */}
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Announcements</h2>
          {announcements.length === 0 ? (
            <p className="text-gray-500 text-sm">No announcements.</p>
          ) : (
            <div className="space-y-3">
              {announcements.slice(0, 5).map((a) => (
                <div key={a.id} className="py-2 border-b last:border-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-medium text-sm">{a.title}</h3>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${
                      a.priority === 'urgent' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                    }`}>{a.priority}</span>
                  </div>
                  <p className="text-xs text-gray-500 line-clamp-2">{a.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
